import React, { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import HeaderCustom from "../../../../components/HeaderCustom";
import { Box, Button, Container, Typography } from "@mui/material";
import SkeletonLoading from "../../../../components/SkeletonLoading";
import '../../../../styles/AppCss.css'
import { Padding, PaletaColor } from "../../../../styles/StylesConstantes";
import { getUsuarios } from "../../../../api/ApiService";
import { DataGrid, GridActionsCellItem } from '@mui/x-data-grid';
import { Add, Delete, Edit } from "@mui/icons-material";
import { useNavigate } from "react-router-dom";


function ObsequiosSubCategoriasPage() {
    const [loading, setLoading] = useState(false);
    const [dataUsuarios, setDataUsuarios] = useState([]);

    let history = useNavigate();

    const stateToken = useSelector(state => state.reducerGlobal.token);
    // console.log("stateToken", stateToken?.body?.token);


    useEffect(() => {
        if (stateToken?.token) {
            handleListarUsuarios();
        }
    }, [stateToken]);

    const handleListarUsuarios = () => {

        getUsuarios(stateToken?.token, 1, 10)
            .then((response) => {
                // console.log("response-getUsuarios", response);
                if (response.data.length > 0) {
                    setDataUsuarios(response.data);
                    setLoading(true);
                } else {
                    setDataUsuarios([]);
                    setLoading(true);
                }
            })
            .catch((error) => {
                console.log("error-getUsuarios", error);
                setDataUsuarios([]);
                setLoading(true);
            });
    };









    //=============================================funcion para editar
    const handleEditClick = (id, row) => () => {
        // console.log('Edit', id, row);
        history('/app/admin/obsequios/subcategoria-detalle/' + id, {
            state: { data: row }
        });
    };


    //=============================================funcion para eliminar
    const handleDeleteClick = (id) => () => {
        console.log('Delete', id);
        setDataUsuarios(dataUsuarios.filter((row) => row.id !== id));
    }


    const columns = [
        {
            field: 'name',
            headerName: 'Nombre',
            editable: true,
            flex: 1
        },
        {
            field: 'categoria',
            headerName: 'Categoría',
            editable: true,
            flex: 1
        },
        {
            field: 'totalCupones',
            headerName: 'Total Cupones',
            editable: true,
            flex: 1
        },
        {
            field: 'totalArticulos',
            headerName: 'Total Articulos',
            editable: true,
            flex: 1
        },
        {
            field: 'totalTransacciones',
            headerName: 'Total Transacciones',
            editable: true,
            flex: 1
        },
        {
            field: 'actions',
            type: 'actions',
            headerName: 'Acciones',
            editable: false,
            flex: 1,
            cellClassName: 'actions',
            getActions: ({ id, row }) => {
                return [
                    <GridActionsCellItem
                        icon={<Edit />}
                        label="Edit"
                        className="textPrimary"
                        onClick={handleEditClick(id, row)}
                        color="inherit"
                    />,
                    <GridActionsCellItem
                        icon={<Delete />}
                        label="Delete"
                        onClick={handleDeleteClick(id)}
                        color="inherit"
                    />,
                ];
            },
        },
    ];


    return (
        <HeaderCustom>
            <div style={{
                marginTop: Padding.P2,
                padding: Padding.P2,
            }}>
                {loading ? (
                    <div>
                        <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: Padding.P2 }}>
                            <Typography variant={'h5'} style={{}}>
                               Subcategorias
                            </Typography>

                            <div style={{}}>
                                <Button
                                    fullWidth
                                    variant="contained"
                                    style={{
                                        backgroundColor: PaletaColor.AZUL_OSCURO,
                                        color: 'white',
                                        fontWeight: 'bold',
                                        // height: 50
                                    }}
                                    startIcon={<Add />}
                                    onClick={() => {
                                        history('/app/admin/obsequios/subcategoria-add');
                                    }}
                                >
                                    Agregar Subcategoria
                                </Button>
                            </div>
                        </div>

                        <div style={{
                            backgroundColor: PaletaColor.BLANCO,
                            borderRadius: Padding.P1,
                            padding: Padding.P3,
                        }}>
                            <Box sx={{ width: '100%' }}>
                                <DataGrid
                                    rows={dataUsuarios}
                                    columns={columns}
                                    initialState={{
                                        pagination: {
                                            paginationModel: {
                                                pageSize: 10,
                                            },
                                        },
                                    }}
                                    pageSizeOptions={[5]}
                                    // checkboxSelection
                                    disableRowSelectionOnClick
                                    //cambiar el texto: No rows
                                    localeText={{
                                        noRowsLabel: 'No hay resultados',
                                        noResultsOverlayLabel: 'No hay resultados',
                                    }}
                                />
                            </Box>
                        </div>
                    </div>
                ) : (
                    <Container sx={{}} style={{}}>
                        <SkeletonLoading />
                    </Container>
                )}


            </div>
        </HeaderCustom>
    );
}

export default ObsequiosSubCategoriasPage;